export class AssetPreloader {
  private loaded = new Map<string, HTMLImageElement>();
  constructor(private limit = 12) {}
  preload(urls: Array<string | null | undefined>): void {
    for (const url of urls.filter((value): value is string => Boolean(value))) {
      if (this.loaded.has(url)) continue;
      const image = new Image(); image.decoding = "async"; image.src = url; this.loaded.set(url, image);
    }
    while (this.loaded.size > this.limit) { const key = this.loaded.keys().next().value as string | undefined; if (!key) break; const image = this.loaded.get(key); if (image) image.src = ""; this.loaded.delete(key); }
  }
  clear(): void { for (const image of this.loaded.values()) image.src = ""; this.loaded.clear(); }
}
